import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import { Tween, Easing } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';

export class BotOptInIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        let rayElement: ElementComponent;
        let iconElement: ElementComponent;
        try {
            rayElement = gameObject.find('ray').getComponent(ElementComponent);

            iconElement = gameObject
                .find('icon')
                .getComponent(ElementComponent);
        } catch (error) {
            console.warn(error);
            return;
        }

        rayElement.layout.angle = 0;
        iconElement.layout.angle = 0;

        const rayRotationTween: Tween = this.getTween(rayElement.layout);
        rayRotationTween
            .to({ angle: 360 }, 5000)
            .repeat(Infinity)
            .start(this.elapsedTime);

        const iconAngleTween: Tween = this.getTween(iconElement.layout);
        const iconScaleTween: Tween = this.getTween(iconElement.layout.scale);

        while (true) {
            yield* this.scaleTo(iconScaleTween, 1.1, 200);
            yield* this.rotateTo(iconAngleTween, -10, 200);
            yield* this.rotateTo(iconAngleTween, 10, 200);
            yield* this.rotateTo(iconAngleTween, -10, 200);
            yield* this.rotateTo(iconAngleTween, 10, 200);
            yield* this.rotateTo(iconAngleTween, 0, 200);
            yield* this.scaleTo(iconScaleTween, 1, 400);
            yield* delay(2000);
        }
    }

    private *scaleTo(
        tween: Tween,
        scale: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ 0: scale, 1: scale }, delay).easing(Easing.Cubic.InOut);
        yield* this.startTween(tween);
    }

    private *rotateTo(
        tween: Tween,
        angle: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ angle: angle }, delay);
        yield* this.startTween(tween);
    }
}
